import { ReactNode, useState } from 'react';
import { MeterUpgradeProcessContext } from './meterUpgradeProcessContext';

export interface IMeterUpgradeProcessProviderProps {
  children?: ReactNode;
}

export const MeterUpgradeProcessProvider = (props: IMeterUpgradeProcessProviderProps) => {
  const [selectedSites, setSelectedSites] = useState<any[]>([]);
  const [filledSitesData, setFilledSitesData] = useState<any[]>([]);
  const [rawGridData, setRawGridData] = useState<any[]>([]);

  return (
    <MeterUpgradeProcessContext.Provider
      value={{
        selectedSites,
        setSelectedSites,
        filledSitesData,
        setFilledSitesData,
        rawGridData,
        setRawGridData,
      }}
    >
      {props.children}
    </MeterUpgradeProcessContext.Provider>
  );
};
